import type { FC, RefObject } from 'react';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';

import type { AnimalIdentifierData } from './AssignIdentifiers.utils';
import type { HoTcolumns } from './AssignIdentifiers.utils';

interface AssignIdentifiersTableV16Props {
  data: Array<AnimalIdentifierData>;
  columns: typeof HoTcolumns;
  innerRef: RefObject<HotTableRef | null>;
  beforeChange: (changes: Array<[number, string | number, unknown, unknown]> | null) => void;
  afterChange: (changes: Array<[number, string | number, unknown, unknown]> | null, source: string) => void;
  maxRows: number;
  setInvalid: (invalid: boolean) => void;
}

const AssignIdentifiersTableV16: FC<AssignIdentifiersTableV16Props> = ({
  data,
  columns,
  innerRef,
  beforeChange,
  afterChange,
  maxRows,
  setInvalid,
}) => {
  const settings: SpreadsheetV16Settings = {
    columns: columns as unknown as SpreadsheetV16Settings['columns'],
    colWidths: 200,
    colHeaders: true,
    rowHeaders: true,
    height: 500,
    rowHeights: 50,
    manualColumnResize: true,
    outsideClickDeselects: true,
    minSpareRows: 0,
    columnSorting: false,
    contextMenu: false,
    className: 'htMiddle',
  };

  return (
    <SpreadsheetV16
      data={data as unknown as Array<Record<string, unknown>>}
      settings={settings}
      innerRef={innerRef as RefObject<HotTableRef>}
      className="mt3"
      beforeChange={beforeChange}
      afterChange={afterChange}
      maxRows={maxRows}
      addCol={false}
      setInvalid={setInvalid}
      testPrefix="assign-identifiers-v16"
    />
  );
};

export default AssignIdentifiersTableV16;
